// extracted by mini-css-extract-plugin
export default {"wrapper":"j7ycDFPh65","focus":"kqruROEOop","read-only":"iMEgGqHXmL","readOnly":"iMEgGqHXmL"};
    if(module.hot) {
      // 1648554224829
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  